import { render } from "./CompanyTransaction.vue?vue&type=template&id=0a554074"
import script from "./CompanyTransaction.vue?vue&type=script&lang=js"
export * from "./CompanyTransaction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__